export enum TourStep {
  START = 0,
  CREATE_TASK_MODAL_OPENED = 1,
  DESCRIPTION_ADDED = 2,
  TASK_SUBMITTED = 3,
  NONE = 4
}
